exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graph-container[data-v-955d80ac] {\n  height: 450px;\n}\n", ""]);

// exports
